const Builder = require('../BuilderBase');
const Button = require('../actionElement/ActionButton');

module.exports = class MenuShell extends Builder {
    constructor(title, properties) {
        super('menuSelection_MenuShell', title, properties);
    }

    button(title, properties) {
        let actionElement = new Button(title, properties);
        this.addChildBlock(actionElement);
        return actionElement;
    }
};
